import { render, staticRenderFns } from "./Course.html?vue&type=template&id=71c3c88b&scoped=true&"
import script from "./Course.vue?vue&type=script&lang=ts&"
export * from "./Course.vue?vue&type=script&lang=ts&"
import style0 from "./Course.scss?vue&type=style&index=0&id=71c3c88b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3c88b",
  null
  
)

export default component.exports